<template>
  <el-input v-model="value" placeholder="TicketFormDistrict 省市区选择"/>
</template>

<script>
export default {
    name : 'TicketFormDistrict',

    props : ['value']
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketFormDistrict.vue